<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">

    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <button type="button" (click)="close()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>

        <div class="relative w-[90%] h-[90%] min-h-0 primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="flex h-full min-h-0 w-full flex-col">
                <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
                    <div class="z-10 grid h-full min-h-0 w-full max-h-full rounded-2xl"
                        [class]="summary() ? 'grid-cols-2' : 'grid-cols-1'">

                        <div class="video-carousel-column col-span-1">
                            <div class="video-carousel-stage">
                                @if (hasPlaylistNavigation() && canGoPrevious()) {
                                <button type="button" (click)="goToPreviousVideo()"
                                    class="video-carousel-nav video-carousel-nav-prev"
                                    aria-label="Previous video">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6" aria-hidden="true">
                                        <path d="m15 18-6-6 6-6" />
                                    </svg>
                                </button>
                                }

                                <article
                                    class="video-carousel-video divide-y divide-gray-200 dark:divide-zinc-700 rounded-lg py-2">
                                    @if (playlistPositionLabel()) {
                                    <div class="video-carousel-position">
                                        <h3>
                                            {{ playlistPositionLabel() }}
                                        </h3>
                                    </div>
                                    }
                                    @if (displayedVideo(); as currentVideo) {
                                    <div class="video-carousel-player-wrap">
                                        @if (slideLoading()) {
                                        <div class="video-carousel-slide-loader" aria-live="polite">
                                            <app-preloader-v2 text="Loading video…"></app-preloader-v2>
                                        </div>
                                        }
                                        <mgc-portfolio-inline-video class="video-carousel-player"
                                            [class.video-carousel-player-hidden]="slideLoading()"
                                            [video]="currentVideo"></mgc-portfolio-inline-video>
                                    </div>
                                    }
                                </article>

                                @if (hasPlaylistNavigation() && canGoNext()) {
                                <button type="button" (click)="goToNextVideo()"
                                    class="video-carousel-nav video-carousel-nav-next"
                                    aria-label="Next video">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6" aria-hidden="true">
                                        <path d="m9 18 6-6-6-6" />
                                    </svg>
                                </button>
                                }
                            </div>
                        </div>

                        @if (summary()) {
                        <article
                            class="col-span-1 flex h-full min-h-0 flex-col gap-y-4 divide-y divide-gray-200 overflow-y-auto rounded-lg border border-gray-200 bg-white p-2 scrollbar-transparent dark:divide-zinc-700 dark:border-zinc-800 dark:bg-zinc-900">

                            <!-- Platform -->
                            <div
                                class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale flex-shrink-0">
                                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                    <div class="flex items-center flex-row gap-x-2">
                                        <div
                                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                            @if (summary()?.platform === 'tiktok') {
                                            <img class="size-6 object-contain mx-auto"
                                                src="https://cdn.getphyllo.com/platforms_logo/logos/logo_tiktok.png"
                                                alt>
                                            } @else if (summary()?.platform === 'instagram') {
                                            <img class="size-6 object-contain mx-auto"
                                                src="https://cdn.getphyllo.com/platforms_logo/logos/logo_instagram_direct.png"
                                                alt>
                                            }
                                        </div>
                                        <div class="">
                                            @if (summary()?.platform === 'tiktok') {
                                            <h3 class="text-sm font-semibold text-primary">TikTok</h3>
                                            } @else if (summary()?.platform === 'instagram') {
                                            <h3 class="text-sm font-semibold text-primary">Instagram</h3>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!-- Platform END -->

                            <!-- Post -->
                            @if (summary()?.post) {
                            <div
                                class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale flex-shrink-0">
                                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                    <div class="flex items-center flex-row gap-x-2">
                                        <div
                                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M10 5h11" />
                                                <path d="M10 12h11" />
                                                <path d="M10 19h11" />
                                                <path d="m3 10 3-3-3-3" />
                                                <path d="m3 20 3-3-3-3" />
                                            </svg>
                                        </div>
                                        <div class="">
                                            <h3 class="text-sm font-semibold text-primary">Post Details</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col gap-y-2">

                                    <p class="text-xs text-secondary">{{ summary()?.post.title }}</p>


                                    <div class="px-2 py-2 grid grid-cols-3 gap-2">
                                        <div class="col-span-1">
                                            <p class="text-xs font-light text-secondary">Views</p>
                                            <p class="text-xs text-primary">{{
                                                formatService.convertIntToString(summary()?.post.view_count) }}</p>
                                        </div>
                                        <div class="col-span-1">
                                            <p class="text-xs font-light text-secondary">Likes</p>
                                            <p class="text-xs text-primary">{{
                                                formatService.convertIntToString(summary()?.post.likes_count) }}</p>
                                        </div>
                                        <div class="col-span-1">
                                            <p class="text-xs font-light text-secondary">Comments</p>
                                            <p class="text-xs text-primary">{{
                                                formatService.convertIntToString(summary()?.post.comment_count) }}</p>
                                        </div>
                                        <div class="col-span-1">
                                            <p class="text-xs font-light text-secondary">Shares</p>
                                            <p class="text-xs text-primary">{{
                                                formatService.convertIntToString(summary()?.post.share_count) }}</p>
                                        </div>
                                        <div class="col-span-1">
                                            <p class="text-xs font-light text-secondary">Saves</p>
                                            <p class="text-xs text-primary">{{
                                                formatService.convertIntToString(summary()?.post.save_count) }}</p>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            }
                            <!-- Post END -->

                            <!-- Music -->
                            @if (summary()?.video_file?.musicInfo) {
                            <div
                                class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale flex-shrink-0">
                                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                    <div class="flex items-center flex-row gap-x-2">
                                        <div
                                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M9 18V5l12-2v13" />
                                                <circle cx="6" cy="18" r="3" />
                                                <circle cx="18" cy="16" r="3" />
                                            </svg>
                                        </div>
                                        <div class="">
                                            <h3 class="text-sm font-semibold text-primary">Music Info</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-3 py-3 flex flex-col gap-y-2">

                                    <div class="flex">
                                        <div class="mr-4 shrink-0 self-center">
                                            @if (summary()?.video_file?.musicInfo.music) {
                                            <button (click)="togglePlayPause()"
                                                class="flex justify-center items-center w-12 h-12 mr-4 rounded-full bg-primary dark:bg-primary text-white hover:bg-primary/95 dark:hover:bg-primary/90 transition"
                                                aria-label="Play or pause audio">
                                                @if (!isPlaying()) {
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="currentColor" class="size-6">
                                                    <path fill-rule="evenodd"
                                                        d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                } @else {
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                    fill="currentColor" class="size-6">
                                                    <path fill-rule="evenodd"
                                                        d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                                }
                                            </button>
                                            } @else {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-6 text-secondary">
                                                <path d="M16 9a5 5 0 0 1 .95 2.293" />
                                                <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                                                <path d="m2 2 20 20" />
                                                <path
                                                    d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                                                <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                                            </svg>
                                            }
                                        </div>
                                        <div>
                                            <h4 class="text-xs font-bold text-primary">{{
                                                summary()?.video_file?.musicInfo.title
                                                }}</h4>
                                            <p class="text-xs text-secondary">{{ summary()?.video_file?.musicInfo.author
                                                }} - {{
                                                summary()?.video_file?.musicInfo.album }}</p>
                                            <p class="text-xs text-secondary">
                                                Duration: {{ summary()?.video_file?.musicInfo.duration }} seconds
                                                @if (!summary()?.video_file?.musicInfo.original) {
                                                <span
                                                    class="ml-2 px-1 text-xs bg-yellow-300 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 rounded">Cover</span>
                                                }
                                            </p>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            }
                            <!-- Music END -->


                            <!-- Summary -->
                            @if (summary()?.content_summary) {
                            <div
                                class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale flex-shrink-0">
                                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                                    <div class="flex items-center flex-row gap-x-2">
                                        <div
                                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M16 5H3" />
                                                <path d="M16 12H3" />
                                                <path d="M11 19H3" />
                                                <path d="m15 18 2 2 4-4" />
                                            </svg>
                                        </div>
                                        <div class="">
                                            <h3 class="text-sm font-semibold text-primary">Content Summary</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="px-2 py-2">
                                    <dl class="divide-y divide-gray-100 dark:divide-zinc-800">
                                        @if (summary()?.content_summary.actions &&
                                        summary()?.content_summary.actions.length >
                                        0) {
                                        <div class="py-2">
                                            <h2 class="text-sm font-semibold text-primary">Actions
                                                <span class="text-xs font-normal text-secondary">({{
                                                    summary()?.content_summary.actions.length }})</span>
                                            </h2>

                                            <div class="mt-2 w-full flex flex-row flex-wrap items-center gap-2">
                                                @for (action of summary()?.content_summary.actions; track $index) {
                                                <span
                                                    class="inline-flex items-center rounded-full bg-blue-50 dark:bg-blue-900/30 px-2 py-0.5 text-xs font-medium text-blue-700 dark:text-blue-400 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-700/50 capitalize">{{
                                                    action }}</span>
                                                }
                                            </div>
                                        </div>
                                        }

                                        @if (summary()?.content_summary.productsShown &&
                                        summary()?.content_summary.productsShown.length > 0) {
                                        <div class="py-2">
                                            <h2 class="text-sm font-semibold text-primary">Products Shown
                                                <span class="text-xs font-normal text-secondary">({{
                                                    summary()?.content_summary.productsShown.length }})</span>
                                            </h2>
                                            <div class="mt-2 w-full flex flex-row flex-wrap items-center gap-2">
                                                @for (product of summary()?.content_summary.productsShown; track $index)
                                                {
                                                <span
                                                    class="inline-flex items-center rounded-full bg-blue-50 dark:bg-blue-900/30 px-2 py-0.5 text-xs font-medium text-blue-700 dark:text-blue-400 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-700/50 capitalize">{{
                                                    product }}</span>
                                                }
                                            </div>
                                        </div>
                                        }

                                        @if (summary()?.content_summary.brandsMentioned &&
                                        summary()?.content_summary.brandsMentioned.length > 0) {
                                        <div class="py-2">
                                            <h2 class="text-sm font-semibold text-primary">Brands Mentioned
                                                <span class="text-xs font-normal text-secondary">({{
                                                    summary()?.content_summary.brandsMentioned.length
                                                    }})</span>
                                            </h2>
                                            <div class="mt-2 w-full flex flex-row flex-wrap items-center gap-2">
                                                @for (brand of summary()?.content_summary.brandsMentioned; track $index)
                                                {
                                                <span
                                                    class="inline-flex items-center rounded-full bg-blue-50 dark:bg-blue-900/30 px-2 py-0.5 text-xs font-medium text-blue-700 dark:text-blue-400 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-700/50 capitalize">{{
                                                    brand }}</span>
                                                }
                                            </div>
                                        </div>
                                        }

                                        @if (summary()?.content_summary.keywordsByIndustry &&
                                        summary()?.content_summary.keywordsByIndustry.length > 0) {
                                        <div class="py-2">
                                            <h2 class="text-sm font-semibold text-primary">Keywords By Industry
                                                <span class="text-xs font-normal text-secondary">({{
                                                    summary()?.content_summary.keywordsByIndustry.length
                                                    }})</span>
                                            </h2>
                                            <div class="mt-2 w-full flex flex-row flex-wrap items-center gap-2">
                                                @for (keyword of summary()?.content_summary.keywordsByIndustry; track
                                                $index) {
                                                <span
                                                    class="inline-flex items-center rounded-full bg-blue-50 dark:bg-blue-900/30 px-2 py-0.5 text-xs font-medium text-blue-700 dark:text-blue-400 ring-1 ring-inset ring-blue-700/10 dark:ring-blue-700/50 capitalize">{{
                                                    keyword }}</span>
                                                }
                                            </div>
                                        </div>
                                        }

                                    </dl>
                                </div>
                            </div>
                            }
                            <!-- Summary END -->


                        </article>
                        }

                    </div>
                </div>
                @if (showFooter) {
                <footer
                    class="sticky bottom-0 z-30 shrink-0 w-full border-t border-gray-200 flex flex-row items-center justify-between pt-2">

                    <div class="flex flex-row items-center justify-start gap-x-2">
                        <button (click)="close()" type="button"
                            class="secondary-button text-primary inline-flex flex-row items-center gap-x-2">
                            Close</button>
                    </div>


                    <div class="flex flex-row items-center justify-end gap-x-2">

                        <button (click)="goToBrief()" type="button" class="inline-flex items-center gap-x-1.5 primary-button">
                            Go to Brief
                        </button>

                        <button (click)="viewSubmission()" type="button" class="inline-flex items-center gap-x-1.5 primary-button">
                            View Submission
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="-mr-0.5 size-5">
                                <path d="M5 12h14" />
                                <path d="m12 5 7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                </footer>
                }
            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>
    </div>
</div>
